import {tns} from 'tiny-slider/src/tiny-slider.module';

let bestResortSliders = [];

export const initBestResorts = () => {
  bestResortSliders = initSliders();
  //window.addEventListener('resize', debounce(sliderResizeListener, 10));
};
export default initBestResorts;

const initSliders = () => {
  const sliderList = [];
  for (const bestResorts of document.getElementsByClassName('best-resorts__slider')) {
    const container = bestResorts.getElementsByClassName('best-resorts__resorts-container')[0];

    const slider = tns({
      container,
      items: 1,
      controlsContainer: bestResorts.getElementsByClassName('best-resorts__controls')[0],
      nav: false,
      lazyload: true,
      gutter: 30,
      responsive: {
        720: {
          edgePadding: 40,
          items: 2
        },
        1260: {
          gutter: '2%',
          loop: false,
        }
      }
    });
    sliderList.push(slider);
  }
  return sliderList;
};
